import { z } from "zod";

/**
 * The field registry as the web app sees it (GET /api/fields, WP-2.3). Served from the one
 * registry in apps/api (ADR-0013): the web app keeps no list of fields of its own.
 */

export const FIELD_TYPES = ["text", "choice", "yes_no", "money", "duration", "list"] as const;
export type FieldType = (typeof FIELD_TYPES)[number];

export const localisedTextSchema = z.object({ it: z.string(), en: z.string() });
export type LocalisedText = z.infer<typeof localisedTextSchema>;

export const fieldCatalogueEntrySchema = z.object({
  key: z.string(),
  section: z.string(),
  type: z.enum(FIELD_TYPES),
  /** Choice fields: the stable values with their labels, in order. Empty otherwise. */
  options: z.array(z.object({ value: z.string(), labels: localisedTextSchema })),
  labels: localisedTextSchema,
  explanations: localisedTextSchema,
  /** The requester may edit it in the live panel (registry source requester / requester_or_document). */
  editable: z.boolean(),
});
export type FieldCatalogueEntry = z.infer<typeof fieldCatalogueEntrySchema>;

export const fieldCatalogueSchema = z.object({
  /** Panel sections in display order. */
  sections: z.array(z.object({ key: z.string(), labels: localisedTextSchema })),
  /** Active fields in display order. */
  fields: z.array(fieldCatalogueEntrySchema),
});
export type FieldCatalogue = z.infer<typeof fieldCatalogueSchema>;
